import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Container, Navbar, Nav, Button } from 'react-bootstrap';
import { LogOut, ShoppingBag, Home } from 'lucide-react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom'; // Ajout de useNavigate
import { io } from 'socket.io-client';

import { SyncService } from './services/SyncService';
import AddItem from './components/AddItem';
import ShoppingList from './components/ShoppingList';
import Login from './components/login';
import RegisterAdmin from './components/RegisterAdmin';
import JoinFamily from './components/JoinFamily';
import Dashboard from './components/Dashboard';

const socket = io('https://api.shopali.re', { 
  transports: ['websocket', 'polling'],
  withCredentials: true
});

const PrivateRoute = ({ children }) => {
  const isAuthenticated = !!localStorage.getItem('token');
  return isAuthenticated ? children : <Navigate to="/login" />;
};

function AppContent() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const location = useLocation();
  const navigate = useNavigate(); // Hook pour naviguer sans recharger

  const handleLogout = () => {
    localStorage.clear();
    navigate('/login'); // Navigation fluide
  };

  useEffect(() => {
    const hId = localStorage.getItem('household_id');
    const token = localStorage.getItem('token');

    if (token && hId && navigator.onLine) {
      socket.emit('join_household', hId);
      SyncService.pullServerChanges();
    }

    socket.on('receive_update', () => {
      console.log("⚡ Signal reçu : Mise à jour de la liste !");
      SyncService.pullServerChanges();
    });

    const goOnline = () => {
      setIsOnline(true);
      if (hId) socket.emit('join_household', hId);
      SyncService.pushLocalChanges();
    };
    
    window.addEventListener('online', goOnline);
    window.addEventListener('offline', () => setIsOnline(false));

    return () => {
      socket.off('receive_update');
      window.removeEventListener('online', goOnline);
    };
  }, []);

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<RegisterAdmin />} />
      <Route path="/join" element={<JoinFamily />} />
      
      <Route path="/dashboard" element={
        <PrivateRoute>
          <Dashboard />
        </PrivateRoute>
      } />

      <Route path="/ma-liste" element={
        <PrivateRoute>
          <div className="pb-5 mb-5">
            <Navbar bg="success" variant="dark" sticky="top" className="shadow-sm">
              <Container>
                <Navbar.Brand className="fw-bold">🛒 Shopali</Navbar.Brand>
                <div className="d-flex align-items-center gap-2">
                  {!isOnline && <small className="text-white-50">Hors-ligne</small>}
                  <Button variant="outline-light" size="sm" onClick={handleLogout} className="border-0">
                    <LogOut size={18} />
                  </Button>
                </div>
              </Container>
            </Navbar>

            <Container className="mt-3">
              <AddItem socket={socket} />
              <ShoppingList socket={socket} />
            </Container>

            <Navbar fixed="bottom" bg="white" className="border-top py-2 shadow-lg">
              <Nav className="w-100 justify-content-around">
                {/* Remplacement par navigate() pour éviter le refresh page */}
                <Nav.Link onClick={() => navigate('/ma-liste')} className={`text-center ${location.pathname === '/ma-liste' ? 'text-success fw-bold' : 'text-muted'}`}>
                  <ShoppingBag size={20}/><br/><small>Courses</small>
                </Nav.Link>
                <Nav.Link onClick={() => navigate('/dashboard')} className={`text-center ${location.pathname === '/dashboard' ? 'text-success fw-bold' : 'text-muted'}`}>
                  <Home size={20}/><br/><small>Foyer</small>
                </Nav.Link>
              </Nav>
            </Navbar>
          </div>
        </PrivateRoute>
      } />

      <Route path="*" element={<Navigate to="/ma-liste" />} />
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;